import { Col, Row } from 'reactstrap';
import { Icon } from '@octano/global-ui';
import useTexts from '../../../hooks/useTexts';

export function ConfirmDeleteContent() {
  const texts = useTexts();
  return (
    <>
      <Row className="justify-content-center">
        <Col xs="auto">
          <Icon name="warning" size="60" />
        </Col>
      </Row>
      <p className="text-dark fs-22 mt-3 mb-4 text-center">
        {texts.delete.title}
      </p>
      <div className="text-dark fs-16 mt-3 text-center">
        {texts.delete.noEvents}
      </div>
    </>
  );
}
